import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { VideoSection } from '../components/VideoSection';
import { IntegrationsSection } from '../components/IntegrationsSection';
import { StatsSection } from '../components/StatsSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { ComparisonTable } from '../components/ComparisonTable';
import { FAQSection } from '../components/FAQSection';
import { ContactForm } from '../components/ContactForm';
import { Button } from '../components/ui/Button';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
function MidPageCTA() {
  const scrollToContact = () => {
    const footerForm = document.getElementById('footer-form');
    if (footerForm) {
      footerForm.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="py-16 bg-[#0A2540]" data-id="element-132">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-134">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-135">
            Ready to Transform Your Dealership's Online Presence?
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-136">
            Let's discuss how a custom website can drive more leads and sales
            for your business.
          </p>
          <Button variant="primary" size="lg" onClick={scrollToContact} className="shadow-lg" data-id="element-137">
            Book A Free Strategy Call
          </Button>
        </motion.div>
      </div>
    </section>;
}
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-138">
      <Navigation data-id="element-139" />
      <HeroSection data-id="element-140" />
      <VideoSection data-id="element-141" />
      <StatsSection data-id="element-142" />

      {/* Why This Matters Section */}
      <section className="py-20 bg-[#0A2540] text-white" data-id="element-143">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-145">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-146">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-147">
                Designed for How Boats{' '}
                <span className="text-[#D4AF37]" data-id="element-148">Are Bought</span>
              </h2>
              <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-149">
                The marine industry is unique. Generic web agencies try to fit
                your dealership into a standard e-commerce box, but boat buyers
                don't shop like shoe buyers.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-150">
                {["Generic templates don't match how boat buyers shop", 'No live inventory syncing leads to frustrated customers', 'No top-boat highlighting hides your best inventory', 'No guided buyer journey results in high bounce rates'].map((item, i) => <li key={i} className="flex items-start" data-id="element-151">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-500/20 flex items-center justify-center mt-1 mr-3" data-id="element-152">
                      <X className="w-4 h-4 text-red-400" data-id="element-153" />
                    </div>
                    <span className="text-gray-300" data-id="element-154">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-white/10 rounded-lg p-6 border border-white/20" data-id="element-155">
                <div className="flex items-start" data-id="element-156">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center mt-1 mr-4" data-id="element-157">
                    <Check className="w-5 h-5 text-green-400" data-id="element-158" />
                  </div>
                  <div data-id="element-159">
                    <h4 className="text-lg font-bold text-white mb-1" data-id="element-160">
                      The DealersChoice Solution
                    </h4>
                    <p className="text-gray-300 text-sm" data-id="element-161">
                      A tailored site becomes a revenue-driving asset:
                      SEO-optimized, conversion-focused, and fully integrated
                      with your inventory systems.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="relative h-full min-h-[400px] rounded-xl overflow-hidden shadow-2xl border border-white/10" data-id="element-162">
              <img src="https://cdn.magicpatterns.com/uploads/3BRoC43rN8wombYQCgSC45/565A8733.jpg" alt="Boats By George marina with family on boat" className="absolute inset-0 w-full h-full object-cover" data-id="element-163" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A2540] via-transparent to-transparent" data-id="element-164" />
              <div className="absolute bottom-6 left-6 right-6" data-id="element-165">
                <p className="text-white font-medium italic" data-id="element-166">
                  "I was able to take my ideas that then magically became this
                  beautiful website."
                </p>
                <p className="text-[#D4AF37] text-sm mt-2 font-bold" data-id="element-167">
                  — Adam Pensel, General Manager at Boats By George
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <IntegrationsSection data-id="element-168" />
      <MidPageCTA data-id="element-169" />
      <FeaturesSection data-id="element-170" />
      <ComparisonTable data-id="element-171" />

      {/* Final CTA Section */}
      <section className="py-24 bg-[#0A2540] relative" style={{
      height: 'auto',
      minHeight: 'fit-content',
      overflow: 'visible'
    }} data-id="element-172">
        {/* Decorative elements */}
        <div className="absolute inset-0 overflow-hidden opacity-20 pointer-events-none" style={{
        zIndex: 0
      }} data-id="element-173">
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#D4AF37] blur-3xl" data-id="element-174" />
          <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#0EA5E9] blur-3xl" data-id="element-175" />
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-176">
          <div className="text-center mb-12" data-id="element-177">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-178">
              Are You Losing Sales Because of Your Website?
            </h2>
            <p className="text-xl text-gray-300 mb-8" data-id="element-179">
              Don't let another season pass with a site that doesn't sell. Talk
              to our marine marketing experts today.
            </p>
          </div>

          <div data-id="element-180">
            <ContactForm id="footer-form" data-id="element-181" />
          </div>
        </div>
      </section>

      <FAQSection data-id="element-182" />

      {/* Simple Footer */}
      <footer className="bg-[#051525] text-gray-400 py-8 border-t border-white/10" data-id="element-183">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-184">
          <div className="text-sm" data-id="element-185">
            © {new Date().getFullYear()} DealersChoice. All rights reserved.
          </div>
          <div className="flex gap-6 text-sm" data-id="element-186">
            <a href="#" className="hover:text-white transition-colors" data-id="element-187">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-188">
              Terms of Service
            </a>
          </div>
        </div>
      </footer>
    </div>;
}